import { useEffect, useLayoutEffect } from 'react';

// A layout effect in the browser, and a plain effect where the page is drawn on the server, which runs neither:
// chosen once when the module loads, so the hook a component calls never changes between its drawings.
export const useIsoLayoutEffect = typeof document === 'undefined' ? useEffect : useLayoutEffect;
